import { useMediaQuery } from '@vueuse/core';
import { computed, type ComputedRef } from 'vue';

/** Viewport móvil del widget (misma ruptura que entry.ts: 640px). */
export function useTouchLikeDevice(): { isTouchLike: ComputedRef<boolean> } {
  const isNarrowViewport = useMediaQuery('(max-width: 639px)');
  const isTouchLike = computed(() => isNarrowViewport.value);

  return { isTouchLike };
}
